<template>
    <div>
        <slot
            :news-categories="newsCategories"
            :update-news-categories="updateNewsCategories"
        ></slot>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    newsCategories: {
        type: Array,
        required: true,
    },
});

const newsCategories = ref(props.newsCategories);

const updateNewsCategories = (event) => {
    if (newsCategories.value.includes(event.target.value)) {
        newsCategories.value = newsCategories.value.filter((item) => {
            return item !== event.target.value;
        });

        // eslint-disable-next-line
        submit();

        return;
    }

    newsCategories.value.push(event.target.value);

    // eslint-disable-next-line
    submit();
};

const submit = () => {
    const searchParams = new URLSearchParams();

    if (newsCategories.value.length) {
        searchParams.append('category', newsCategories.value.join(','));
    }

    window.location.href = `/news?${searchParams.toString()}`;
};

</script>
